<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12 text-xs-center>
        <h2>Modules</h2>
        <p class="grey--text">Register to have full access of the modules</p>
      </v-flex>
      <v-flex v-for="(module, i) in sampleModules" :key="i" md4>
        <v-card height="400">
          <v-card-media
            :src="module.image"
            height="200"
          >
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <div class="title mb-3">{{ module.title }}</div>
              <div class="mb-3">{{ module.description }}</div>
              <strong>
                <span>CPD Points</span>
                <v-avatar color="primary" size="30">
                  <span class="white--text">{{ module.cpd_points }}</span>
                </v-avatar>
              </strong>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import config from '../../../configApi'
const apiUrl = config.apiUrl

export default {
  computed: {
    sampleModules () {
      return this.modules.slice(0, 3) // get first 3 elements
    }
  },
  data () {
    return {
      modules: []
    }
  },
  methods: {
    getModules () {
      if (navigator.onLine) {
        console.log('User is online - Fetching info from server')
        axios.get(apiUrl + '/home/module').then((e) => {
          if (e.data.length > 0) {
            this.$set(this, 'modules', e.data)
          }
        }).catch((e) => {
          console.log('error', e)
        })
      } else {
        console.log('User is offline - Fetching info from localstorage')
      }
    }
  },
  mounted () {
    this.getModules()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/sampleModules.vue